import React from "react";
import "./ApplePortfolio.css";
import ApplePortfolio from "./ApplePortfolio";

function App() {
  return <ApplePortfolio />;
}

export default App;
